// extracted by mini-css-extract-plugin
export default {"container":"ModifierGroupListPage_container__z03sH","noResults":"ModifierGroupListPage_noResults__n9qe6"};